module.exports = __webpack_public_path__ + "static/img/MS.7ce3610.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MS.png
// module id = nUU4
// module chunks = 34